enum CustomerJourneyTag {
  RENTAL = 'RENTAL',
  ADOPTION = 'ADOPTION',
  DEMO = 'DEMO',
  OUT_OF_ORDER = 'OUT_OF_ORDER',
  RETENTION = 'RETENTION',
  SALES = 'SALES',
}

export default CustomerJourneyTag;

export const getCustomerJourneyTags = () => Object.values(CustomerJourneyTag);

export const getCustomerJourneyTagsAsString = () => {
  return getCustomerJourneyTags().map((t) => t as string);
};
